// common/services/player/deleteFamilyContact.ts
import req from '../../api/request'
import { familyContactDeletePath, type FamilyScope } from './familyScope'

export type DeleteFamilyContactInput = {
  /** Player whose family the contact belongs to. */
  playerId: string
  /** The contact being removed. */
  contactId: string
  /** Which backend routes to use. Omitted → self-scoped ('me'). */
  scope?: FamilyScope
}

export type DeleteFamilyContactResponse = {
  id?: string
  status?: 'deleted'
} & Record<string, unknown>

/**
 * DELETE a family contact from the player's family (route chosen by `scope`).
 */
export const deleteFamilyContact = async (
  input: DeleteFamilyContactInput
): Promise<DeleteFamilyContactResponse> => {
  const { data } = await req(
    familyContactDeletePath(input.playerId, input.contactId, input.scope),
    { method: 'DELETE' }
  )
  return data as DeleteFamilyContactResponse
}
